module.exports = __webpack_public_path__ + "static/media/p1000-tip-box.7d855cc0.svg";